const hostname = "dev";

let ENV = "dev";
if (hostname.includes("localhost")) ENV = "local";
else if (hostname.includes("216.48.186.233")) ENV = "dev";
 else if (hostname.includes("digitaluat.qgirco.com")) ENV = "uat";
else if (hostname.includes("digital.qgirco.com")) ENV = "live";
const ENV_CONFIG = {
  local: {
    ENV: "local",
    APPROVAL: "http://localhost:5001/approval",
    BASE: "http://localhost:7778/api",
    WHATSAPPURL: "http://localhost:7779/api",
    PAYMENT:"http://216.48.186.233:8081",
    PDFDOWNLOAD: "http://164.52.220.212:8093",
     SCANNER: "http://localhost:8081/api/api/vehicle/vehicleScanner",
     MAIL:"http://localhost:7778/api/email"
  },
  dev: {
    ENV: "dev",
    APPROVAL: "http://216.48.186.233:5555/approval",
    BASE: "http://216.48.186.233:7778/api",
    WHATSAPPURL: "http://216.48.186.233:7779/api",
    PAYMENT:"http://216.48.186.233:8081",
    // PDFDOWNLOAD: "http://164.52.220.212:8093",
    PDFDOWNLOAD: "http://qcqgib2c.insursaapp.com:7093",
     SCANNER: "https://216.48.186.233:8084/api/api/vehicle/vehicleScanner",
      MAIL:"http://216.48.186.233:7778/api/email"
  },
  uat: {
    ENV: "uat",
    APPROVAL: "https://digitaluat.qgirco.com:5556/approval",
    BASE: "https://digitaluat.qgirco.com:7778/api",
    WHATSAPPURL: "https://digitaluat.qgirco.com:7779/api",
    PAYMENT:"https://digitaluat.qgirco.com:8081",
    PDFDOWNLOAD: "https://digitaluat.qgirco.com",
    SCANNER: "https://digitaluat.qgirco.com:7778/api/vehicle/vehicleScanner-uat",
     MAIL:"https://digitaluat.qgirco.com:7778/api/email"
  },
  live: {
    ENV: "live",
    APPROVAL: "https://renewal.qgirco.com/approval",
    BASE: "https://digital.qgirco.com:7778/api",
    WHATSAPPURL: "https://digital.qgirco.com:7779/api",
     PAYMENT:"https://digital.qgirco.com:8081",
   PDFDOWNLOAD: "https://digital.qgirco.com",
   SCANNER: "https://digital.qgirco.com:7778/api/vehicle/vehicleScanner-prod",
    MAIL:"https://digital.qgirco.com/api/email"
  },
};
export { ENV };                 
export default ENV_CONFIG[ENV];
